import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';
import { ProductClick } from '@app/shared/components/products-arrangement/products-arrangement.component';

@Component({
  selector: 'vc-product-section',
  templateUrl: './product-section.component.html',
  styleUrls: ['./product-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSectionComponent {
  @Input()
  title: string;
  @Input()
  productList: Product[];
  @Input()
  seoContext: string[] = [];
  @Input()
  itemMax: number;
  @Input()
  isSlider: boolean;
  @Input()
  isCms: boolean;

  @Output() productClick = new EventEmitter<ProductClick>();

  onProductClick(event: ProductClick) {
    this.productClick.emit(event);
  }
}
